import type { DomainEntry } from '@/mocks/domains';

interface DomainCardProps {
  domain: DomainEntry;
}

export default function DomainCard({ domain }: DomainCardProps) {
  const statusConfig = {
    stable: { label: '稳定', className: 'bg-emerald-100 text-emerald-700' },
    new: { label: '最新', className: 'bg-primary-100 text-primary-700' },
    backup: { label: '备用', className: 'bg-secondary-100 text-secondary-700' },
  };

  const status = statusConfig[domain.status];
  const speedClass = domain.speed === 'fast' ? 'text-emerald-600' : 'text-amber-600';

  return (
    <a
      href={domain.url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="group flex items-center justify-between p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
          <i className="ri-link text-lg text-primary-600"></i>
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="font-medium text-sm text-foreground-900 truncate">{domain.url}</span>
            <span className={`px-1.5 py-0.5 text-xs rounded-full font-medium flex-shrink-0 ${status.className} whitespace-nowrap`}>
              {status.label}
            </span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="whitespace-nowrap">
              <i className={`ri-signal-wifi-line mr-1 ${speedClass}`}></i>
              {domain.speed === 'fast' ? '极速' : '正常'}
            </span>
            <span className="whitespace-nowrap">
              更新于 {domain.lastChecked}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0 ml-4">
        <span className="text-xs text-primary-600 font-medium whitespace-nowrap group-hover:translate-x-0.5 transition-transform">
          立即访问
        </span>
        <i className="ri-arrow-right-line text-sm text-primary-500 group-hover:translate-x-1 transition-transform"></i>
      </div>
    </a>
  );
}